/* eslint-disable */
import axios from "axios";
import store from "@/store";
import VPagination from "@hennge/vue3-pagination";
import KriInfoModal from "./KriInfoModal.vue";
import MitigationInfoModal from "./Mitigationinfomodal.vue";
import ManageRiskItemModal from "./ManageRiskItemModal.vue";
import ViewRiskInfoModal from "./ViewRiskInfoModal.vue";

export default {
    name: "RiskRegistry",
    components: {
        VPagination,
        KriInfoModal,
        MitigationInfoModal,
        ManageRiskItemModal,
        ViewRiskInfoModal,
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            rollsprivilages: "",
            token: "",
            studyId: "",
            loading: false,
            riskList: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            totalPages: 1,
            SortProperty: "riskId",
            SortOrder: 0,

            searchField: {
                riskId: "",
                ctqId: "",
                riskCategory: "",
            },

            // Drill-down into the existing KRI popup
            selectedCtqForKri: null,
            showKriModal: false,

            // Create / Edit risk item popup
            showManageRiskModal: false,
            riskEditData: null,
            manageRiskCtqContext: null,

            selectedCtqForMitigation: null,
            showMitigationModal: false,

            selectedRiskForView: null,
            showViewRiskModal: false,
        };
    },

    async mounted() {
        this._studyIdChangedHandler = async () => {
            this.rollsprivilages = store.getters.getRolesprivilegeData;
            this.studyId = store.getters.getStudyIs;
            this.token = store.getters.getIdToken;
            this.currentPage = 1;
            await this.fetchRiskList();
        };
        window.addEventListener("studyIdChanged", this._studyIdChangedHandler);
        this.rollsprivilages = store.getters.getRolesprivilegeData;
        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.fetchRiskList();
    },

    beforeUnmount() {
        window.removeEventListener("studyIdChanged", this._studyIdChangedHandler);
    },

    methods: {
        async fetchRiskList(page = this.currentPage) {
            this.loading = true;
            this.riskList = [];

            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/ctq/getallrisk`,
                    {
                        params: {
                            StudyId: this.studyId,
                            RiskId: this.searchField.riskId || undefined,
                            CtqId: this.searchField.ctqId || undefined,
                            RiskCategory: this.searchField.riskCategory || undefined,
                            pageindex: page,
                            pagesize: this.pageSize,
                            SortProperty: this.SortProperty,
                            SortOrder: this.SortOrder,
                        },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result = response.data;

                if (result.entities && Array.isArray(result.entities)) {
                    this.riskList = result.entities.map(i => ({ ...i, expanded: false }));
                    this.totalCount = result.totalCount || 0;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (Array.isArray(result)) {
                    this.riskList = result.map(i => ({ ...i, expanded: false }));
                    this.totalCount = result.length;
                    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
                } else if (result) {
                    this.riskList = [{ ...result, expanded: false }];
                    this.totalCount = 1;
                    this.totalPages = 1;
                }

                this.currentPage = page;
            } catch (error) {
                console.error("Error fetching risk list:", error);
                this.riskList = [];
                this.totalCount = 0;
                this.totalPages = 0;
            } finally {
                this.loading = false;
            }
        },

        loadPage(page) {
            this.fetchRiskList(page);
        },

        searchReports() {
            this.currentPage = 1;
            this.fetchRiskList();
        },

        sortSelected(property) {
            if (this.SortProperty === property) {
                this.SortOrder = this.SortOrder === 0 ? 1 : 0;
            } else {
                this.SortProperty = property;
                this.SortOrder = 0;
            }
            this.currentPage = 1;
            this.fetchRiskList();
        },

        // KriInfoModal is keyed off the CtQ (ctqid), not an individual risk,
        // so we build the CtQ context from this row's own ctqId/ctqFactor.
        viewKriForRisk(item) {
            this.selectedCtqForKri = { ctqid: item.ctqId, ctqFactor: item.ctqFactor };
            this.showKriModal = true;
        },

        closeKriModal() {
            this.showKriModal = false;
            this.selectedCtqForKri = null;
        },

        ViewMitigation(item) {
            this.selectedCtqForMitigation = item;
            this.showMitigationModal = true;
        },

        closeMitigationModal() {
            this.showMitigationModal = false;
            this.selectedCtqForMitigation = null;
        },

        viewRisk(item) {
            this.selectedRiskForView = item;
            this.showViewRiskModal = true;
        },

        closeViewRiskModal() {
            this.showViewRiskModal = false;
            this.selectedRiskForView = null;
        },

        // ── Edit risk item ──────────────────────────────────────
        openManageRiskModal(item) {
            this.riskEditData = item ? { ...item } : null;
            this.manageRiskCtqContext = item
                ? { ctqid: item.ctqId, ctqFactor: item.ctqFactor }
                : null;
            this.showManageRiskModal = true;
        },


        closeManageRiskModal() {
            this.showManageRiskModal = false;
            this.riskEditData = null;
            this.manageRiskCtqContext = null;
        },

        reloadRiskList() {
            this.currentPage = 1;
            this.fetchRiskList();
        },

        truncate(text) {
            if (!text) return "";
            return text.length > 120 ? text.substring(0, 120) + "..." : text;
        },

        toggleExpand(item) {
            item.expanded = !item.expanded;
        },

        riskLevelBadgeClass(level) {
            switch ((level || "").toLowerCase()) {
                case "high":
                    return "badge badge-warning";
                case "medium":
                    return "badge badge-info";
                case "low":
                    return "badge badge-success";
                default:
                    return "badge badge-secondary";
            }
        },
    },
};